import React from "react";
import './index.scss';
import check from "../../images/check.svg";
import { ReactSVG } from "react-svg";
import apple from "../../images/app_store_button.svg";
import google from "../../images/google_play_button.svg";
import { useMediaQuery } from "@material-ui/core";
import appleQR from "../../images/apple_myarx_qrcode.svg";
import googleQR from "../../images/google_myarx_qrcode.svg";
import { strings } from "../../strings/strings";

export const MyArx2 = () => {
    const isTabletOrMobile = useMediaQuery('(max-width: 1023px)');

    return <div className='myarx'>
        <div className="myarx_label">{strings.myARX2.meta}</div>
        <h3 className="myarx_header">{strings.myARX2.title}</h3>

        <div className="myarx_list">
            {strings.myARX2.items.map(item =>
                <div className="myarx_list-item" key={item}>
                    <ReactSVG src={check} />
                    <span>{item}
                    </span>
                </div>)}
        </div>

        <div className="myarx_buttons">
            {
                isTabletOrMobile ?
                    <a href={strings.refs.myarx_apple} target="_blank"
                        rel="noopener noreferrer">
                        <ReactSVG src={apple} />
                    </a>
                    :
                    <div className="myarx_qr">
                        IOS
                        <img src={appleQR} alt='apple qr code' />
                    </div>
            }
            {
                isTabletOrMobile ?
                    <a href={strings.refs.myarx_android}
                        target="_blank" rel="noopener noreferrer">
                        <ReactSVG src={google} />
                    </a>
                    :
                    <div className="myarx_qr">
                        Android
                        <img src={googleQR} alt='android qr code' />
                    </div>
            }
        </div>
    </div>
}